import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AddEngagementComponent } from './add-engagement.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TreeTableModule } from 'primeng/treetable';
import { PaginatorModule } from 'primeng/paginator';
import { AddEngagementRoutingModule } from './add-engagement-routing.module';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { BasicDetailsComponent } from './components/basic-details/basic-details.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { CardModule } from 'primeng/card';
import { ContactsComponent } from './components/contacts/contacts.component';
// import {AddRowDirective} from '../directives/add-row.directive';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { from } from 'rxjs';
import { FolderStructureComponent } from './components/folder-structure/folder-structure.component';
import { TreeModule } from 'primeng/tree';
import { TreeDragDropService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputMaskModule } from 'primeng/inputmask'
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastModule } from 'primeng/toast';
import { LanguageComponent } from './components/language/language.component';
import { EditorModule,TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { AddEngagementMemoryService } from './add-engagement-memory-service/add-engagement-memory.service';


@NgModule({
  imports: [
    CommonModule,
    NgMultiSelectDropDownModule,
    FormsModule,
    TreeTableModule,
    PaginatorModule,
    ReactiveFormsModule,
    AddEngagementRoutingModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatIconModule,
    MatStepperModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatSnackBarModule,
    EditorModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MultiSelectModule,
    PanelModule,
    CardModule,
    TableModule,
    DropdownModule,
    ButtonModule,
    DialogModule,
    ToggleButtonModule,
    TreeModule,
    ConfirmDialogModule,
    TooltipModule,
    CalendarModule,
    InputSwitchModule,
    InputMaskModule,
    NgxSpinnerModule,
    ToastModule
  ],
  declarations: [AddEngagementComponent,
    BasicDetailsComponent,
    ContactsComponent,
    FolderStructureComponent,
    LanguageComponent,
    // , AddRowDirective
  ],
  providers: [
    MatDatepickerModule,
    TreeDragDropService,
    ConfirmationService,
    CalendarModule,
    AddEngagementMemoryService,
    MessageService,
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [],
})

export class AddEngagementModule { }
